import React from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import {
  AuditFields,
  DashedSeparator,
  EditButton,
  CompanyName,
  ExternalLink
} from "MODULES/shared/components";
import EditQuote from "MODULES/IncomingQuotes/Detail/Edit/EditQuote";
import { CODE, COMPANY, EMAIL, ID, NAME, PHONE } from "APP_ROOT/constants";
import { CONTACT, WEBSITE } from "MODULES/companies/constants";
import { PORTAL_PURCHASE } from "MODULES/PurchaseOrders/constants";
import { BUYER, FULL_NAME } from "MODULES/users/constants";
import { updateIncomingQuote } from "../actions";

export default class DetailsTable extends React.Component {
  state = {
    editOpen: false
  };
  openModal = () => {
    this.setState({ editOpen: true });
  };

  closeEditModal = () => {
    this.setState({ editOpen: false });
  };

  render() {
    const { incomingQuote } = this.props;
    const { editOpen } = this.state;
    return (
      <div className="panel panel-default">
        <div className="panel-body">
          <h2 style={{ marginTop: 10 }}>
            Details
            <EditButton handleClick={this.openModal} />
            <EditQuote
              quote={incomingQuote.toJS()}
              updateQuote={updateIncomingQuote}
              open={editOpen}
              close={this.closeEditModal}
            />
          </h2>
          <table className="table table-condensed">
            <tbody>
              <tr>
                <th>Buyer</th>
                <td>{incomingQuote.getIn([BUYER, FULL_NAME])}</td>
              </tr>
              <tr>
                <th>Vendor Code</th>
                <td>{incomingQuote.getIn([COMPANY, CODE])}</td>
              </tr>
              <tr>
                <th>Vendor Name</th>
                <td>
                  {incomingQuote.getIn([COMPANY, ID]) ? (
                    <CompanyName company={incomingQuote.toJS().company} />
                  ) : (
                    `${incomingQuote.get("legacy_company_name")} (LEGACY)`
                  )}
                </td>
              </tr>
              <tr>
                <th>Vendor Phone</th>
                <td>{incomingQuote.getIn([COMPANY, PHONE])}</td>
              </tr>
              {incomingQuote.get(PORTAL_PURCHASE) && (
                <tr>
                  <th>Vendor Portal</th>
                  <td>
                    <ExternalLink
                      url={incomingQuote.getIn([COMPANY, WEBSITE])}
                    />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {!incomingQuote.get(PORTAL_PURCHASE) && [
            <DashedSeparator />,
            <table className="table table-condensed">
              <tbody>
                <tr>
                  <th>Contact</th>
                  <td>{incomingQuote.getIn([CONTACT, NAME])}</td>
                </tr>
                <tr>
                  <th>Contact Email</th>
                  <td>
                    <a href={`mailto:${incomingQuote.getIn([CONTACT, EMAIL])}`}>
                      {incomingQuote.getIn([CONTACT, EMAIL])}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          ]}
          <hr />
          <AuditFields record={incomingQuote} multiLine />
        </div>
      </div>
    );
  }
}

DetailsTable.propTypes = {
  incomingQuote: PropTypes.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Detail/DetailsTable.jsx